export default "__VITE_ASSET__12907a29__"